import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Button,
  HStack,
  VStack,
  StackDivider,
  Text,
} from '@chakra-ui/react';

import { useParams, useNavigate } from 'react-router-dom';

import updateGroupCart from '~/firebase/update/updateGroupCart';

import { PLATFORM_ID } from '~/globalVariables';
import { CartStatus } from '~/types/cart';

type LeaveOrCancelGroupModalProps = {
  isOpen: boolean;
  isHost: boolean;
  onClose: () => void;
};

export default function LeaveOrCancelGroupModal({
  isOpen,
  isHost,
  onClose,
}: LeaveOrCancelGroupModalProps) {
  const { groupId = '' } = useParams();
  const navigate = useNavigate();

  const handleConfirm = async () => {
    if (!isHost) {
      return navigate('/');
    }

    if (!groupId) {
      return;
    }

    try {
      await updateGroupCart(PLATFORM_ID, groupId, {
        status: CartStatus.CANCELED,
      });
      navigate('/');
    } catch (err) {}
  };

  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} isCentered>
      <ModalOverlay />
      <ModalContent mx={4}>
        <ModalBody py={5}>
          <VStack spacing={5}>
            <Text fontWeight="bold" fontSize="lg">
              {isHost ? '確定取消揪團？' : '確定離開揪團？'}
            </Text>
            <Text fontSize="sm">
              {isHost ? '放到購物車的餐點將會被清空' : '您將會離開揪團頁面'}
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter p={0}>
          <HStack
            w="full"
            spacing={0}
            borderTopWidth="1px"
            borderColor="gray.400"
            divider={<StackDivider borderColor="gray.400" />}
          >
            <Button isFullWidth variant="unstyled" fontWeight="normal" onClick={handleConfirm}>
              確定
            </Button>
            <Button isFullWidth variant="unstyled" fontWeight="normal" onClick={onClose}>
              我想一下
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
